import { Moment } from "moment"

export enum dateTypes {
    globalFilterDateFormat = 'YYYY-MM-DDTHH:mm:ss',
    globalFilterDateFormatNoSeconds = 'YYYY-MM-DDTHH:mm',
    dateFormatFromDisplayInfoNoSeconds = 'DD/MM/YYYY HH:mm',
    dateFormatFromDisplayInfo = 'DD/MM/YYYY HH:mm:ss',
    dateFormatFromDisplayInfoBrackets = 'DD/MM/YYYY [a las] HH:mm',
    dateFormatFromDisplayInfoBracketsSs = 'DD/MM/YYYY [a las] HH:mm:ss',
    dateFormatFromDisplayInfoHyphenMins = 'DD_MM_YYYYTHH_mm',
    dateFormatFromDisplayInfoHyphenMinsAndSeconds = 'DD_MM_YYYYTHH_mm_ss',
    dateFormatFromDisplayInfoHyphen = 'DD_MM_YYYY',
    dateFilesFormat = 'DD/MM/YYYY - HH:mm:ss',
    dateYearFormat = 'DD-MM-YYYY',
    dateYearFormatBars = 'DD/MM/YYYY',
    dateYearFormatReverse = 'YYYY-MM-DD',
    dateYearFormatReverseHhMmSs = 'YYYY-MM-DDTHH:mm:ss',
    hoursAndMinutesFormat = 'HH:mm',
    hoursAndMinutesFormatMinus = 'hh:mm',
    hoursAndMinutesAndSeconds = 'HH:mm:ss',
    hoursAndMinutesAndSecondsBrackets = 'HH[H]mm[M]ss[S]',
    dddLT = 'ddd, LT',
    seconds = 'ss'
}

export enum diffOptions {
    day = 'day',
    days = 'days',
    years = 'years',
    hours = 'hours',
    minutes = 'minutes',
    seconds = 'seconds'
}

export interface HoursAndMinutes {
 hour: number, 
 minute: number 
}

export type inputDateFormat = dateTypes | string | HoursAndMinutes | Moment | number | Date
